import { z } from "zod";

import { isoDate } from "./iso-date-schema";

export const catalogType = z.enum([
  "PRODUCT",
  "SERVICE",
  "MATERIAL",
  "EQUIPMENT",
]);

export const catalogItemStatus = z.enum([
  "Draft",
  "Active",
  "Inactive",
  "Deprecated",
  "Archived",
]);

export const lineItemType = z.enum(["SERVICE", "PRODUCT", "LABOR", "FEE"]);
export const lineItemProvidedBy = z.enum(["BIRDWATCH", "CUSTOMER"]);
export const unitTypeGroup = z.enum([
  "LENGTH",
  "TIME",
  "PACKAGED",
  "WEIGHT",
  "AREA",
  "QUANTITY",
  "VOLUME",
]);
export const catalogItemSchema = z.object({
  id: z.string(),
  sku: z.string().nullable(),
  name: z.string(),
  description: z.string().nullable(),
  type: catalogType,
  cost: z.number().nullable(),
  price: z.number().nullable(),
  rate: z.number().nullable(),
  userCreatedId: z.string(),
  isFlatPrice: z.boolean(),
  createdAt: isoDate,
  updatedAt: isoDate,
  isPublic: z.boolean(),
  unitTypeKey: z.string().nullable(),
  markup: z.number().nullable(),
  catalogItemLabors: z.any().nullish(),
  catalogItemAssemblies: z.any().nullish(),
  lineItemType: lineItemType.nullish(),
  lineItemUnitType: z.any().nullish(),
  category: z.any().nullish(),
});
